import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Checkbox from '@/components/UI/Checkbox';
import { useBorrowerConfirmFundraising } from '@/query/queries/fundraising/useBorrowerConfirmFundraising.js';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const BorrowerConfirmBlock = ({ fundraisingId }) => {
  const { t } = useTranslation('fundraising');
  const [checked, setChecked] = useState(false);
  const [touched, setTouched] = useState(false);
  const { mutateAsync: confirm } = useBorrowerConfirmFundraising(fundraisingId);

  const onConfirm = async () => {
    await confirm();
  };

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.inner}>
          <div className={s.checkboxes}>
            <Checkbox
              name="has_accepted_terms"
              isChecked={checked}
              onChange={() => {
                setChecked(!checked);
                setTouched(true);
              }}
              render={() => (
                <span className={classnames('f-14', !checked && touched && s.error)}>
                  <Trans
                    ns="fundraising"
                    i18nKey="borrower.confirm_checkbox"
                    components={{
                      LinkTerms: <MyLink href={APP_LINKS.docTermsOfUse} underline isExternal />,
                      LinkAssigmentAgreement: (
                        <MyLink href={APP_LINKS.docAssignmentAgreement} underline isExternal />
                      ),
                      LinkSuretyAgreement: (
                        <MyLink href={APP_LINKS.suretyAgreement} underline isExternal />
                      ),
                    }}
                  />
                </span>
              )}
            />
          </div>
          <div className={s.buttons}>
            <button
              type="button"
              disabled={!checked}
              className={classnames(r.black_large, r.shrink_height)}
              onClick={onConfirm}
            >
              {t('fundraising:borrower.confirm_participation')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
